// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/hooks/useNow.ts
// 🔧 PURPOSE: L'orologio della Home: "adesso", aggiornato allo scoccare di
//             ogni minuto e subito quando l'ospite torna sull'app. Senza,
//             una Home rimasta aperta resterebbe ferma: niente passaggio
//             alla vista del soggiorno alle 15:00 del giorno di arrivo,
//             saluto del mattino la sera, "Stasera" il giorno dopo.
//             Come il minuto di MyStay, ma allineato all'orologio e senza
//             lavorare mentre l'app è in background.
// ============================================

import { useEffect, useState } from 'react';

const MINUTE_MS = 60_000;

export function useNow(stepMs: number = MINUTE_MS): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timer: number | null = null;

    const schedule = () => {
      if (timer !== null) window.clearTimeout(timer);
      // Allo scoccare del prossimo passo (il minuto dell'orologio, non
      // "fra sessanta secondi da quando si è aperta la pagina").
      const wait = stepMs - (Date.now() % stepMs) + 50;
      timer = window.setTimeout(tick, wait);
    };
    const tick = () => {
      timer = null;
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      setNow(new Date());
      schedule();
    };
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      setNow(new Date());
      schedule();
    };

    schedule();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      if (timer !== null) window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, [stepMs]);

  return now;
}

export default useNow;
